import { Box, Flex } from "@chakra-ui/react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import axiosInstance from "../../config/axiosInstance";
import PaginationControls from "../Customer-dashboard/ReceptionistOrders/PaginationControls";
import SearchBar from "../Customer-dashboard/ReceptionistOrders/SearchBar";
import Filters from "./Filters";
import OrdersTable from "./OrdersTable";
import Stats from "./Stats";
export default function AssignedOrders() {
  const [orders, setOrders] = useState([]);
  const [filters, setFilters] = useState({ orderstatus: [] });
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pagination, setPagination] = useState({ total: 0, totalPages: 0 });
  // ✅ Default to today's date
  const [fromDate, setFromDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(dayjs().format("YYYY-MM-DD"));
const [stats, setStats] = useState({});
  const fetchOrders = async () => {
    const params = {
      page,
      limit: pageSize,
      search,
      ...filters,
      fromDate,
      toDate,
    };

    if (Array.isArray(params.orderstatus)) {
      params.orderstatus = params.orderstatus.join(",");
    }

    try {
      const res = await axiosInstance.get("/api/master-stats/tailor-order", {
        params,
      });
      setOrders(res.data.orders);
      setPagination(res.data.pagination);
    } catch (err) {
      console.log({ title: "Error loading orders", status: "error" });
    }
  };
    const fetchStats = async () => {
      try {
          const res = await axiosInstance.get("/api/master-stats/assigned-tailor-stats", {
          params: { fromDate, toDate },
        });
        setStats(res.data.stats);
      } catch (error) {
        console.error("Error fetching stats:", error.message);
      }
    };

  useEffect(() => {
    fetchOrders(); // fetch orders when dependencies change
    // eslint-disable-next-line
  }, [page, pageSize, filters, search, fromDate, toDate]);

  return (
    <Box p={{ base: 4, md: 8 }}>
      <Stats
        fromDate={fromDate}
        toDate={toDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
        fetchStats={fetchStats}
        setStats={setStats}
        stats={stats}
      />
      <Box p={4}>
        <Flex justify="space-between" wrap="wrap" mb={4} gap={3}>
          <SearchBar search={search} setSearch={setSearch} />
          <Filters
            filters={filters}
            setFilters={setFilters}
            fetchOrders={fetchOrders}
            resetPage={() => setPage(1)}
          />
        </Flex>

        <OrdersTable
        fetchOrders={fetchOrders}
        fetchStats = {fetchStats}
          data={orders}
        />

        <PaginationControls
          page={page}
          totalPages={pagination.totalPages}
          onPageChange={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
        />
      </Box>
      {/* <OTPModal isOpen={isOtpOpen} onClose={onOtpClose} /> */}
    </Box>
  );
}
